export default {
  parkJsonEndpoint: process.env.VUE_APP_PARK_JSON_BASE_URL,
  CDNBaseUrl : process.env.VUE_APP_CDN_BASE_URL,
  kenticoBaseUrl : process.env.VUE_APP_KENTICO_BASE_URL
};